import { useEffect, useState } from "react"
import API from "../../../services/API"
import Layout from "../../Frames/Layout"
import Grid from "../../Tools/Grid";
import { Button, Link as A } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import moment from "moment";
import Avatar from "../../Tools/Avatar";

export default function Conversions(){

    const { id } = useParams();

    const columns = [
        {
            field: 'type',
            headerName: 'Conversion',
            width: 170,
            valueGetter: p => p.row.type?.title
        },
        {
            field: 'value',
            headerName: 'Valeur €',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.value
        },
        {
            field: 'user',
            headerName: 'Contact',
            width: 70,
            align: 'center',
            valueGetter: p => p.row.user?.id,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Link to={`/crm/persons/${p.value}`}>
                    <Avatar
                        initials={p.row.user?.initials} 
                        color={p.row.user?.category?.color || 'grey'} 
                        size={36} 
                    />
                </Link>,
        },
        {
            field: 'name',
            headerName: 'Nom',
            width: 180,
            valueGetter: p => p.row.user?.name
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            valueGetter: p => p.row.user?.email,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <A href={`mailto:${p.value}`}>{p.value}</A>
        },
        {
            field: 'phone',
            headerName: 'Tél',
            width: 150,
            valueGetter: p => p.row.user?.phone,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <A href={`tel:${p.value}`}>{p.value}</A>
        },
        {
            field: 'course',
            headerName: 'Formation',
            width: 250,
            valueGetter: p => p.row.course?.title
        },
        {
            field: 'date',
            headerName: 'Date',
            width: 200,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated && 
                moment(p.value).format('DD/MM/YYYY HH:mm')
        },
        {
            field: 'enrollmentType',
            headerName: 'PEC',
            width: 200,
            valueGetter: p => p.row.enrollmentType?.title || ''
        },
        {
            field: 'completion',
            headerName: 'Complétion %',
            width: 120,
            type: 'number',
            valueGetter: p => p.row.completion
        },
    ];

    const [items, setItems] = useState(null)

    useEffect(() => {

        API.get(`/sticker/actions/${id}/conversions`)
            .then(r => setItems(r.data))

    }, [id])


    return <Layout title="Pixel LearnyLib" menu="marketing" tab="sticker">

        <Button 
            startIcon={<ArrowBack />} 
            sx={{mb: 1}}
            component={Link}
            to="/marketing/sticker/actions"
        >
            Actions
        </Button>
    
        <Grid 
            id='stickerConversionsGrid'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{ value: 'sum' }}
        />

    </Layout>
}